import { ShopOutlined } from '@ant-design/icons';
import { Button, Flex } from 'antd';
import { useTranslation } from 'react-i18next';

import { usePartnerProgramsQuery } from '@/hooks/queries/usePartnerProgramsQuery';
import { useCurrentUser } from '@/hooks/useCurrentUser';
import Avatar from '@/UI/Avatar/Avatar';
import HeaderIconPopover from '@/UI/HeaderIconPopover/HeaderIconPopover';
import { openInNewTab } from '@/utils/routes';

const LinksMenuPopup = () => {
  const { data: partnerPrograms = [] } = usePartnerProgramsQuery();
  const [t] = useTranslation();
  const { user } = useCurrentUser();

  const replaceUserIdInLink = (link: string) => {
    if (user === null) return link;
    return link.replace('{{user_id}}', user.id);
  };

  if (partnerPrograms.length === 0) {
    return null;
  }

  return (
    <HeaderIconPopover
      ariaLabel={t('PARTNER_PROGRAMS')}
      buttonTestId="partner-programs-trigger"
      icon={<ShopOutlined />}
      popoverStyles={{ content: { width: '280px' } }}
      content={(close) => (
        <Flex vertical>
          {partnerPrograms.map((program) => (
            <Button
              key={program.link}
              type="text"
              block
              aria-label={program.name}
              onClick={() => {
                openInNewTab(replaceUserIdInLink(program.link));
                close();
              }}
            >
              <Avatar
                size="small"
                src={program.icon}
                shape="circle"
                title={program.name}
              />
            </Button>
          ))}
        </Flex>
      )}
    />
  );
};

export default LinksMenuPopup;
